import { render, staticRenderFns } from "./BlocoBiomas.vue?vue&type=template&id=30583e78&scoped=true&lang=pug"
import script from "./BlocoBiomas.vue?vue&type=script&lang=js"
export * from "./BlocoBiomas.vue?vue&type=script&lang=js"
import style0 from "./BlocoBiomas.vue?vue&type=style&index=0&id=30583e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30583e78",
  null
  
)

export default component.exports